module.exports = __webpack_public_path__ + "static/media/truth-is-all-there-is.2566d05e.jpg";